export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="flex flex-col justify-between gap-4 xl:flex-row xl:items-end">
    <div className="min-w-0">
      {eyebrow ? (
        <p className="text-xs font-extrabold uppercase tracking-[0.24em] text-beam-blue">{eyebrow}</p>
      ) : null}
      <h1 className="mt-2 font-display text-3xl font-extrabold sm:text-4xl">{title}</h1>
      {description ? (
        <p className="mt-2 max-w-2xl text-sm font-semibold leading-6 text-beam-graphite/65">{description}</p>
      ) : null}
    </div>
    {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
  </div>
);
